// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Ripple from 'vue-ripple-directive';
import moment from 'moment-timezone';
import VueAgile from 'vue-agile';
import { VueMaskDirective } from 'v-mask';
import Vue2Leaflet from 'vue2-leaflet';
import VueI18n from 'vue-i18n';

import Vue2Filters from 'vue2-filters';

import bugsnag from 'bugsnag-js';
import bugsnagVue from 'bugsnag-vue';

import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.css';

import Icon from '@/components/components/Icon';

import calculateUrl from './lib/calculate-on-site-url';
import setBackendUrl from './lib/set-backend-url';
import gaId from './lib/ga-id';
import stats from './lib/stats';
import users from './lib/user';
import setBrowserBody from './lib/set-body-browser';

calculateUrl();
setBackendUrl();
gaId();
stats();
users();
setBrowserBody();

import API from '@/classes/API'; // eslint-disable-line

import App from './App'; // eslint-disable-line
import router from './router'; // eslint-disable-line
import store from './store'; // eslint-disable-line

import languageDetector from './mixins/languageDetector'; // eslint-disable-line

const bugsnagClient = bugsnag('fd8bdcec90ef947041b02b76794ed7c4');
bugsnagClient.use(bugsnagVue(Vue));

Vue.config.productionTip = false;

Vue.directive('ripple', Ripple);
Vue.directive('mask', VueMaskDirective);
Vue.use(VueAgile);

Vue.use(Vue2Filters);

Vue.use(VueI18n);

Vue.use(VueIziToast);

Vue.component('v-map', Vue2Leaflet.Map);
Vue.component('v-tilelayer', Vue2Leaflet.TileLayer);
Vue.component('v-marker', Vue2Leaflet.Marker);

moment.locale('sv');

Vue.component('icon', Icon);

const dateFormatting = (value, format) => {
  const v = value;
  let f = format;

  if (!v) {
    return '';
  }

  if (!f) {
    f = 'D[/]M';
  }

  const formatMap = {
    day: 'D',
    week: 'W',
    'weekday-short': 'ddd',
    weekday: 'dddd',
    month: 'MMMM',
    short: 'D[/]M',
    long: 'D MMMM',
    iso: 'YYYY-MM-DD',
    'short-with-time': 'D[/]M HH:mm',
    'short-with-full-time': 'D[/]M HH:mm:ss',
  };

  if (formatMap[f]) {
    f = formatMap[f];
  }

  return moment(v).format(f);
};

Vue.filter('date', dateFormatting);

Vue.filter('dateRange', (value, format, separator) => {
  const a = dateFormatting(value[0], format);
  const b = dateFormatting(value[1], format);

  if (a === b) {
    return a;
  }
  return a + (separator || '-') + b; // eslint-disable-line prefer-template
});

Vue.filter('moment', value => moment(value));

Vue.filter('fromNow', value => moment(value).fromNow());

Vue.filter('capitalize', value => (value.charAt(0).toUpperCase()) + value.slice(1));

Vue.filter('join', value => value.join(', '));

Vue.filter('weekday', (value) => {
  const days = ['s', 'm', 'tu', 'w', 'th', 'f', 'sa', 'su'];
  if (typeof value === 'object') {
    return value.map(v => window.SITE_CONFIG.translations.general.weekdays.long[days[v]]);
  }
  return window.SITE_CONFIG.translations.general.weekdays.long[days[value]];
});

Vue.filter('currency', (value, config) => {
  let options = config;

  if (typeof options === 'undefined') {
    options = {};
  }

  let v = value;
  let s = typeof options.symbol === 'undefined' ? true : options.symbol;
  const f = options.freeIfZero || false;

  if (typeof s === 'undefined') {
    s = true;
  }

  if (typeof v === 'undefined') {
    return '';
  }

  if (v === null) {
    return '';
  }

  v = parseFloat(v.toString().replace(',', '.'));
  v = Math.round(v);

  if (v === 0 && f) {
    return window.SITE_CONFIG.translations.general.free.toUpperCase();
  }

  return v.toLocaleString('sv') + (s ? ':-' : '');
});

window.screenMobile = 690;
window.screenTablet = 995;
window.screenDesktop = 1440;

window.screenSize = () => window.innerWidth;

async function getConfig() {
  const detector = languageDetector;

  let language = localStorage.getItem('language');

  // TODO
  if (['sv', 'da', 'en'].indexOf(language || '') === -1) {
    const lang = detector.methods.getBrowserSimpleLanguage(
      detector.methods.getBrowserLanguage(window.navigator.language),
    );

    if (['sv', 'da', 'en'].indexOf(lang || '') === -1) {
      language = 'sv';
    } else {
      language = lang;
    }
  }

  localStorage.setItem('language', language);

  moment.locale(language);

  const data = await API.get('config');
  window.SITE_CONFIG = data;

  Vue.mixin({
    computed: {
      SITE_CONFIG() {
        return window.SITE_CONFIG;
      },
    },
    methods: {
      FEATURE_IS_ACTIVE(feature) {
        return window.SITE_CONFIG.features[feature] && window.SITE_CONFIG.features[feature];
      },
      FEATURE_IS_NOT_ACTIVE(feature) {
        return typeof window.SITE_CONFIG.features[feature] === 'undefined' || !window.SITE_CONFIG.features[feature];
      },
      SETTING(setting) {
        return window.SITE_CONFIG.settings[setting] || null;
      },
    },
  });

  Vue.mixin({
    methods: {
      number(input) {
        return parseInt(input, 10) || 0;
      },
    },
  });

  const skiSchoolFilter = {};

  /*eslint-disable */
  for (var i in window.SITE_CONFIG.skischool.ages) {
    if (!store.state.skiSchoolFilter[window.SITE_CONFIG.skischool.ages[i][1]]) {
      skiSchoolFilter[window.SITE_CONFIG.skischool.ages[i][1]] = false;
    } else {
      skiSchoolFilter[window.SITE_CONFIG.skischool.ages[i][1]] = store.state.skiSchoolFilter[window.SITE_CONFIG.skischool.ages[i][1]];
    }
  }
  for (var i in window.SITE_CONFIG.skischool.levels) {
    if (!store.state.skiSchoolFilter[i]) {
      skiSchoolFilter[i] = false;
    } else {
      skiSchoolFilter[i] = store.state.skiSchoolFilter[i];
    }
  }
  skiSchoolFilter.date = store.state.skiSchoolFilter.date || null;
  store.commit('setSkischoolFilter', skiSchoolFilter);
  /*eslint-enable */

  const messages = {};
  messages[language] = {};

  messages[language] = window.SITE_CONFIG.translations;

  // Create VueI18n instance with options
  const i18n = new VueI18n({
    locale: language,
    messages, // set locale messages
  });


  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
    i18n,
  });
}

document.body.classList.add('booking-web');

getConfig();

window.VERSION_NUMBER = 107;



// WEBPACK FOOTER //
// ./src/main.js